import React from 'react';
import { RecaptchaNotice } from '../../../../components/ReCaptchaContainer';
import { useRegisterComponent } from '../../../orchestrator';

export const SignupRecaptchaNotice = () => {
  useRegisterComponent(SignupRecaptchaNotice.name);
  return <RecaptchaNotice />;
};
